import PropTypes from "prop-types";

export const DatetimeFieldPropTypes = {
  fieldName: PropTypes.string,
  fieldUID: PropTypes.string,
  fieldType: PropTypes.string,
  datetimeType: PropTypes.string,
};
